<template>
	<CardSlashed v-if="showCard" class="card-link card-link-primary card-margin-bottom">
		<template #left>
			<div class="col-12 align-end card-link-body p-3">
				<div class="card-link-title">
					<div class="align-text">
						<h2>{{getString('dont_you_have_pos')}}</h2>
						<p>{{getString('take_advantage_of_the_promotion')}}</p>
					</div>
				</div>
				<div class="card-link-actions mb-15 mt-10" v-if="userStore.currBusiness">
					<AppButton @click="GoToShop" :text="getString('go_to_shop')" outline inverted/>
				</div>
				<div class="card-link-title border-top-divider pt-10">
					<div class="align-text">
						<h2>{{getString('download_ttp_app')}}</h2>
						<p>{{getString('free_download_app')}}</p>
					</div>
				</div>
				<div class="card-link-actions mt-10" v-if="userStore.currBusiness">
					<div class="align-row-item">
						<div class="button-download">
							<a target="_blank" href="https://apps.apple.com/it/app/qromo-gestionale/id6670559241">
								<img :src="'https://img.qromo.io/img/app-store-badge'+linkSuffix+'.svg'" alt="download app button">
							</a>
						</div>
						<div class="button-download">
							<a target="_blank" href="https://play.google.com/store/apps/details?id=it.cromosrl.qromo">
								<img :src="'https://img.qromo.io/img/play-store-badge'+linkSuffix+'.svg'" alt="download app button">
							</a>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template #right>
			<div class="wrapper-img">
				<picture>
					<source type="image/webp" srcset="https://img.qromo.io/img/All-POS-new-def.webp">
					<img src="https://img.qromo.io/img/All-POS-new-def.jpg" alt="product image">
				</picture>
			</div>
		</template>
	</CardSlashed>
</template>

<script>
import {useLanguageStore, useSvgStore} from "@/shared/stores";
import { useUserStore} from "@/console-new/stores";
import CardSlashed from "@/console-new/components/shared/CardSlashed.vue";
import AppButton from "@/shared/components/AppButton.vue";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let svgStore = useSvgStore();
		const userStore = useUserStore();
		return {getString: languageStore.getString, userStore, languageStore, getIcon: svgStore.get};
	},
	name: "CardSlashedTapToPay",
	components: {AppButton, CardSlashed},
	computed: {
		showCard() {
			return (!this.userStore.businessTerminals || this.userStore.businessTerminals.length < 1) &&
				(!this.userStore.paxTerminals || this.userStore.paxTerminals.length < 1) &&
				(!this.userStore.dojoTerminals || this.userStore.dojoTerminals.length < 1);
		},
		linkSuffix() {
			return this.languageStore.lang !== 'it' ? "-en" : "";
		},
	},
	methods: {
		GoToShop() {
			this.$router.push("/plugins/shop");
		},
	}
}
</script>

<style scoped lang="scss">
.card-link {
	:deep(.card-body) {
		padding: 0;
		& > .list-container {
			.list-item:first-child::before {
				display: none;
			}
			.list-item:last-child::after {
				display: none;
			}
		}
	}
	.card-link-title {
		width: 100%;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		.icon-plugins {
			display: inline-block;
			width: 15px;
			height: 15px;
			margin-top: 5px;

			&:deep(svg) {
				width: 15px;
				height: 15px;
				.fill { fill: var(--color-txt-white); }
				.stroke { stroke: var(--color-txt-white); }
			}
		}
		.align-text {
			display:flex;
			flex-direction: column;
		}
		h2 {
			font-size: 22px;
			display: inline-block;
			color: var(--color-txt-white);
			@media (max-width: 550px) {
				font-size: 20px;
				line-height: normal;
			}
		}
		p {
			font-size: 14px;
			line-height: 18px;
			color: var(--color-txt-white);
			margin-top: 5px;
		}
		&.no-icon {
			h2 {
				width: 100%;
				padding-left: 0;
			}
		}

		&.border-top-divider {
			border-top: 1px solid rgba(255,255,255,.5);
		}
	}
	.card-link-body {
		height: 100%;
		padding: 15px;
		.card-link-actions {
			position: relative;
			.align-row-item {
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 20px;
				.button-download {
					width: auto;
					display: flex;
					align-items: center;
					a:after  {
						display: none;
					}

					img {
						object-fit: contain;
						width: 100%;
						height: 40px;
					}
				}
			}

		}
	}
	&-primary {
		&:deep(.slashed-card-container) {
			background: linear-gradient(198deg, rgb(139, 61, 245) 0%, rgb(47, 36, 209) 100%);
			.slashed-left {
				padding-right: 0;
				width: 80%;
				@media (max-width: 550px) {
					width: 100%;
					padding-right: 10px;
					padding-bottom: 10px;
					padding-top: 0;
				}
				.align-end {
					align-items: flex-start;
				}
			}
			.slashed-right {
				display: flex;
				align-items: center;
				justify-content: center;
				@media (max-width: 550px) {
					padding-top: 10px;
					padding-bottom: 0;
				}
			}
			@media (max-width: 550px) {
				flex-direction: column-reverse;
			}
		}
	}
	.wrapper-img {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		picture {
			img {
				width: 100%;
				height: 100%;
				max-height: 220px;
				object-fit: contain;
				@media (max-width: 550px) {
					max-height: 190px;
				}
			}
		}
	}
}
</style>